// extracted by mini-css-extract-plugin
module.exports = {"container":"success_container__2J0Vf","title":"success_title__3Q97c","btn":"success_btn__3IiNI"};